<ngx-slick-carousel [config]="clientSlideConfig">
	<div class="image-wrap" ngxSlickItem *ngFor="let content of sliderContent">
	   <img src="{{content}}" alt="client image" width="466" height=297>
	</div>
   <!-- image-wrap close -->
</ngx-slick-carousel>